import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { HeroSection } from "@/components/landing/HeroSection";
import {
  ThreeWaysSection, ValuesSection, HowItWorksSection, NeighbourHelpSection,
  CollectivesSection, RecognitionSection,
} from "@/components/landing/InfoSections";
import { FeaturedOrgsSection, StoriesSection } from "@/components/landing/DynamicSections";
import { ForOrgsSection, FinalCtaSection } from "@/components/landing/ClosingSections";
import { LaunchInterestBanner } from "@/components/landing/LaunchInterestBanner";

// Landing page — data fetching + referral banner live here; all presentation
// moved to components/landing/* (Phase 15 component split, behaviour unchanged).
export default function Landing() {
  const [stats, setStats] = useState({ total_hours: 0, volunteers: 0, organisations: 0, open_opportunities: 0 });
  const [featured, setFeatured] = useState([]);
  const [stories, setStories] = useState([]);
  const [refBanner, setRefBanner] = useState(false);
  const [sp] = useSearchParams();

  useEffect(() => {
    // ?ref= may have been stripped by the preview wrapper before Landing mounted.
    // index.js snapshots it into sessionStorage at bootstrap — read from either source.
    const urlRef = sp.get("ref");
    let storedRef = null;
    try { storedRef = sessionStorage.getItem("ref_code"); } catch { /* ignore */ }
    const ref = urlRef || storedRef;
    if (ref) {
      const clean = String(ref).toUpperCase().trim();
      if (/^[A-Z0-9]{6,12}$/.test(clean)) {
        try { sessionStorage.setItem("ref_code", clean); } catch { /* ignore */ }
        setRefBanner(true);
      }
    }
    api.publicStats().then(setStats).catch(() => {});
    api.featuredOrgs().then(setFeatured).catch(() => setFeatured([]));
    // Item 1 (2026-07): landing shows ONLY admin-featured stories, and only
    // when at least 3 exist (StoriesSection hides itself below that).
    api.stories(3, undefined, true).then(setStories).catch(() => setStories([]));
  }, [sp]);

  return (
    <div className="bg-cream overflow-x-clip">
      <Seo description="CivicHearth connects volunteers, organisations, collectives and neighbours across the UK. Give an hour, ask for a hand, or bring your street together — every bit counts." />
      {refBanner && (
        <div data-testid="ref-banner" className="bg-amber-100 border-b border-amber-200 text-amber-900 text-sm py-2 text-center">
          👋 Invited by a friend — sign up and start volunteering.
        </div>
      )}
      <HeroSection stats={stats} />
      <ThreeWaysSection />
      <ValuesSection />
      <HowItWorksSection />
      <NeighbourHelpSection />
      <CollectivesSection />
      <RecognitionSection />
      <FeaturedOrgsSection featured={featured} />
      <StoriesSection stories={stories} />
      <ForOrgsSection />
      {/* Landing polish (2026-07): interest banner moved from position 3 to
          just above the final CTA — let the page make its case first. */}
      <LaunchInterestBanner />
      <FinalCtaSection />
    </div>
  );
}
